import { isSSR } from '@repo/ui/src/utils/isSSR';

export const waitForAnalytics = () =>
  new Promise<void>((resolve) => {
    if (isSSR) {
      resolve();
      return;
    }

    window.dataLayer = window.dataLayer || [];
    resolve();
  });

type Func = (...args: any[]) => any;

export const track = async <T extends Func>(
  func: T,
  props: Omit<Parameters<T>[0], 'affiliation'>,
) => {
  await waitForAnalytics();
  func({
    affiliation: 'website',
    ...props,
  });
};
